<template>
  <a
    class="open-in-maps"
    :href="is_valid ? maps_href : '#'"
    :target="is_valid ? target : '_self'"
    :disabled="!is_valid"
    rel="noopener noreferrer"
  >Vedi sulla mappa</a>
</template>

<script>
  export default {
    name: 'open-in-maps',
    props: {
      location: {
        type: Object,
        required: true,
      },
      target: {
        type: String,
        default: '_blank',
      },
      only_use_coordinates: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      is_valid() {
        const use_apple_maps = /iPhone|iPad|iPod/.test(navigator.userAgent);
        if (use_apple_maps) {
          return (
            this.has_valid_coordinates(this.location) &&
            this.has_valid_name(this.location)
          );
        }
        return this.only_use_coordinates
          ? this.has_valid_coordinates(this.location)
          : this.has_valid_name(this.location);
      },
      maps_href() {
        const { name, city, coordinates = {} } = this.location;
        const { latitude, longitude } = coordinates;
        const use_apple_maps = /iPhone|iPad|iPod/.test(navigator.userAgent);
        if (use_apple_maps) {
          return `https://maps.apple.com/?q=${encodeURIComponent(name)}&ll=${latitude},${longitude}`;
        }
        let query = encodeURIComponent([name, city].filter(Boolean).join(', '));
        if (this.only_use_coordinates) {
          query = `${latitude},${longitude}`;
        }
        return `https://www.google.com/maps/search/?api=1&query=${query}`;
      },
    },
    methods: {
      has_valid_coordinates(location) {
        if (!location) {
          return false;
        }
        const { coordinates } = location;
        if (!coordinates) {
          return false;
        }
        return !!(coordinates && coordinates.latitude && coordinates.longitude);
      },
      has_valid_name(location) {
        if (!location) {
          return false;
        }
        return !!location.name;
      },
    },
  };
</script>
